var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-danger",on:{"click":function($event){return _vm.mostrarJustificativa()}}},[_c('i',{staticClass:"fa fa-asterisk icon-button",attrs:{"title":("Desp. viagem ajustada: " + (_vm.despViagem.justificativa))}})])}
var staticRenderFns = []

export { render, staticRenderFns }